'use strict';

angular.module('shiftTraderApp')
    .directive('saHourPicker', function () {
      var theTemplate = '<div class="sa_hour_picker_container">' +
          '<div class="top_line clearfix">' +
            '<div class="hour_label" data-ng-repeat="obj in topLine" data-ng-click="buttonTap(obj.value)" data-ng-class="{selected: isSelected(obj), sa_timepicker_meridian: $last}">' +
              '{{obj.label}}' +
            '</div>' +
          '</div>' +
          '<div class="bottom_line clearfix">' +
            '<div class="hour_label" data-ng-repeat="obj in bottomLine" data-ng-click="buttonTap(obj.value)" data-ng-class="{selected: isSelected(obj), sa_timepicker_meridian: $last}">' +
              '{{obj.label}}' +
            '</div>' +
          '</div>' +
        '</div>';

      return {
        template: theTemplate,
        restrict: 'EA',
        scope: {
          hour:'=saHourPicker'
        },
        link: function(scope, elem) {
          scope.currentHour = scope.hour;

          scope.$watch('hour', function(val) {
            if (val !== scope.currentHour) {
              scope.currentHour = val;
            }
          });



          scope.topLine = [
            {
              label: '12',
              value: 0
            },
            {
              label: '1',
              value: 1
            },
            {
              label: '2',
              value: 2
            },
            {
              label: '3',
              value: 3
            },
            {
              label: '4',
              value: 4
            },
            {
              label: '5',
              value: 5
            },
            {
              label: 'am',
              value: 'am'
            }
          ];

          scope.bottomLine = [
            {
              label: '6',
              value: 6
            },
            {
              label: '7',
              value: 7
            },
            {
              label: '8',
              value: 8
            },
            {
              label: '9',
              value: 9
            },
            {
              label: '10',
              value: 10
            },
            {
              label: '11',
              value: 11
            },
            {
              label: 'pm',
              value: 'pm'
            }
          ];

          scope.isSelected = function(obj) {
            if (obj.label === 'am') {
              return scope.currentHour < 12;
            } else if (obj.label === 'pm') {
              return scope.currentHour >= 12;
            } else {
              if (scope.currentHour >= 12) {
                return obj.value === (scope.currentHour - 12);
              } else {
                return obj.value === scope.currentHour;
              }
            }
          };

          scope.buttonTap = function(val) {
            if (val === 'am' || val === 'pm') {
              if (scope.currentHour < 12 && val === 'pm') {
                scope.currentHour += 12;
              } else if (scope.currentHour >= 12 && val === 'am') {
                scope.currentHour -= 12;
              }
            } else {
              if (scope.currentHour >= 12 ) {
                scope.currentHour = val + 12;
              } else {
                scope.currentHour = val;
              }
            }

            scope.hour = scope.currentHour;
          };
        }
      };
    });
